import { SafetyCertificateFilled } from '@ant-design/icons';
import {
  Alert,
  CardAvatar,
  CardHeader,
  VerticalSpace,
  FocusedCard,
} from '@brokerbay/design-components';
import React from 'react';
import { SUPPORT_EMAIL } from 'utils/constants';

const AlreadyClaimedView = () => (
    <FocusedCard>
      <VerticalSpace>
        <CardHeader
          title={undefined}
          icon={<CardAvatar icon={SafetyCertificateFilled} />}
        />

        <Alert
          message={
            <p>
              It looks like your brokerage has already been claimed.
              <br />
              <br />
              Please email{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> for
              assistance.
            </p>
          }
        />
      </VerticalSpace>
    </FocusedCard>
  );

export default AlreadyClaimedView;
